var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mainlist',{attrs:{"color":"#fff","items":_vm.adresses,"list":_vm.list}})}
var staticRenderFns = []

export { render, staticRenderFns }